import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'
import { functionalitiesApi } from '../../api/api.functionalities.service'

export default {
  [actionTypes.GET_USER_TYPES_AND_FUNCTIONALITIES]: store => {
    return functionalitiesApi.GetUserTypesAndFunctionalities().then(res => {
      return store.commit(mutationTypes.SET_USER_TYPES_AND_FUNCTIONALITIES, {
        isCustomer: res.isClient,
        isParticipant: res.isParticipant,
        functionalities: res.functionalities,
      })
    })
  },
}
